export enum PageType {
  Requests = 'requests',
  Passes = 'passes'
}
